import { useContext, useState } from 'react';
import { ActionModal } from '../../../../../../components/Modal';
import React from 'react';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import HandlingUnitInfoPane from '../Panes/HandlingUnitInfoPane';
import { HandlingUnit } from '../../../../../../../types/handling_unit/handlingUnit';
import { Button, CancelButton } from '../../../../../../components/Button';
import useMutation from '../../../../../../../hooks/useMutation';
import {
  HandlingUnitMutations,
  UpdateHandlingUnitResponse,
  UpdateHandlingUnitVariables,
} from '../../../../../../../graphql/handlingUnit.graphql';
import { HandlingUnitContext } from '../../../../../../../context/HandlingUnitContext';
import { useToast } from '../../../../../../../providers/ToastProvider';
import { ToastType } from '../../../../../../components/Toast';
import { HandlingUnitInput } from '../../../../../../../types/handling_unit/handlingUnit.input';

interface UpdateHandlingUnitModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  item?: HandlingUnit;
}

export default function UpdateHandlingUnitModal({ open, setOpen, item }: UpdateHandlingUnitModalProps) {
  const { showToast } = useToast();

  const { handlingUnits, setHandlingUnits } = useContext(HandlingUnitContext);

  const [input, setInput] = useState<HandlingUnitInput>(new HandlingUnitInput(item));

  const handleActionCompleted = (hu: HandlingUnit) => {
    setHandlingUnits(new Map(handlingUnits.set(hu.id, hu)));
    setOpen(false);
  };

  const [update, { loading }] = useMutation<UpdateHandlingUnitResponse, UpdateHandlingUnitVariables>(
    HandlingUnitMutations.update,
    {
      variables: { handlingUnits: [input.forUpdate()] },
      onCompleted: response => {
        handleActionCompleted(response.updateHandlingUnit[0]);
        showToast({
          type: ToastType.success,
          title: t(TranslationKey.handlingUnitUpdatedSuccessfullyToastTitle).singular.upper,
        });
      },
    },
  );

  const footer = (
    <div className='flex justify-end gap-2'>
      <CancelButton onClick={() => setOpen(false)} disabled={loading} />
      <Button
        onClick={() => update()}
        text={t(TranslationKey.update).singular.upper}
        loading={loading}
        disabled={!input.validate() || !input.hasChanges(undefined)}
      />
    </div>
  );

  return (
    <ActionModal
      title={t(TranslationKey.handlingUnitUpdate).singular.upper}
      open={open}
      setOpen={setOpen}
      footer={footer}
    >
      <HandlingUnitInfoPane input={input} setInput={setInput} />
    </ActionModal>
  );
}
